<template>
  <transition name="trk-fade">
    <div
      v-if="busy"
      class="trk-api-busy"
      aria-live="polite"
      aria-busy="true"
      role="status"
    >
      <div class="trk-api-busy__panel">
        <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
        <span>Loading…</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TrackingApiLoader',
  computed: {
    busy() {
      const service = this.$onboardingTrackingService;
      return !!(service && service.loadingState && service.loadingState.active);
    }
  }
};
</script>
